export default __webpack_public_path__ + "static/media/1.954f9dc4.jpg";